
function formatMoney (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

document.querySelectorAll('.cart_quantity_selector .qty_btn').forEach((btn) => {
  btn.addEventListener('click', () => {
    const QuantityDiv = btn.parentElement.querySelector('.quantity_div');
    let value = Number(QuantityDiv.textContent);
    const isPlus = btn.classList.contains('quantity_plus');
    const row = btn.closest('.cart_item');
    if (!row) return;
    const index = parseInt(row.getAttribute('data-index'));

    if (isPlus) {
      const newValue = value + 1;
      changeItemQuantity(index, newValue, QuantityDiv);
    } else if (value >= 1) {
      const newValue = value - 1;
      changeItemQuantity(index, newValue, QuantityDiv);
    }
  });
});

function updateCartIconBubble() {
  fetch('/cart?section_id=cart-icon-bubble')
    .then((response) => response.text())
    .then((html) => {
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const source = parsedHtml.getElementById('shopify-section-cart-icon-bubble') || parsedHtml.body;
      const target = document.getElementById('cart-icon-bubble');
      if (target && source) {
        target.innerHTML = source.innerHTML;
      }
    })
    .catch((err) => console.error('Error updating cart bubble:', err));
}

function changeItemQuantity(index, quantity, quantity_div) {
  axios.post('/cart/change.js', { line: index, quantity }).then((res) => {
    const format = document.querySelector('[data-money-format]')?.getAttribute('data-money-format') || '${{amount}}';
    const totalPrice = formatMoney(res.data.total_price, format);
    
    // Self-healing lookup for the updated item
    const row = quantity_div.closest('.cart_item');
    const key = row ? row.getAttribute('data-key') : null;
    
    let item = null;
    if (res.data && res.data.items) {
      if (key) {
        const cleanKey = String(key).trim();
        item = res.data.items.find((it) => {
          const itemKey = String(it.key || '').trim();
          const itemVariantId = String(it.variant_id || '').trim();
          const itemId = String(it.id || '').trim();
          return itemKey === cleanKey || 
                 itemVariantId === cleanKey || 
                 itemId === cleanKey ||
                 itemKey.replace(/:$/, '') === cleanKey.replace(/:$/, '');
        });
      }
      
      // Fallback 1: match by index
      if (!item && typeof index === 'number' && !isNaN(index)) {
        item = res.data.items[index - 1];
      }
      
      // Fallback 2: match by variant ID extracted from key
      if (!item && key) {
        const variantIdFromKey = key.split(':')[0];
        item = res.data.items.find((it) => String(it.variant_id) === String(variantIdFromKey));
      }
    }

    if (!item || quantity === 0) {
      if (row) row.remove();
      
      // Re-index remaining cart items
      document.querySelectorAll('.cart_item').forEach((itemRow, idx) => {
        itemRow.setAttribute('data-index', idx + 1);
      });

      const totalPriceEl = document.querySelector('#total_price');
      if (totalPriceEl) totalPriceEl.textContent = totalPrice;
      
      updateCartIconBubble();

      if (res.data.item_count < 1) {
        window.location.reload();
      }
      return;
    }

    if (res.data.item_count < 1) {
      window.location.reload();
      return;
    }

    const priceValue = item.final_line_price !== undefined ? item.final_line_price : (item.line_price !== undefined ? item.line_price : 0);
    const itemPrice = formatMoney(priceValue, format);
    
    const totalPriceEl = document.querySelector('#total_price');
    if (totalPriceEl) totalPriceEl.textContent = totalPrice;

    if (row) {
      const lineItemPriceEl = row.querySelector('.line_item_price');
      if (lineItemPriceEl) lineItemPriceEl.textContent = itemPrice;
      
      // Update data-key in case Shopify regenerated it (e.g. due to discounts or quantity change)
      if (item.key) {
        row.setAttribute('data-key', item.key);
      }
    }
    
    quantity_div.textContent = quantity;
    updateCartIconBubble();

  }).catch(err => {
    console.error(err);
    const msg = err.response && err.response.data && err.response.data.message 
      ? err.response.data.message 
      : (err.response && err.response.data && err.response.data.description ? err.response.data.description : err.message);
      
    const row = quantity_div.closest('.cart_item');
    if (row) {
      const errElement = row.querySelector('.errElement');
      if (errElement) {
        errElement.textContent = msg;
        errElement.classList.remove('hidden');
        setTimeout(() => {
          errElement.textContent = '';
        }, 5000);
      }
    }
  });
}
